<div class="notification-box-icon">
  <a routerLink="/notification/box">
    <i class="icosun-bell"></i>
    <div *ngIf="hasNotificationPending" class="notification-box-icon_pending"></div>
  </a>
</div>
